"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
function Benefit(props) {
    var className = props.className, style = props.style, title = props.title, describe = props.describe, icon = props.icon, backgroundColor = props.backgroundColor;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var bgClass = backgroundColor ? 'has-bg' : '';
    return (react_1.default.createElement("section", { style: __assign({ background: backgroundColor }, style), className: (0, classnames_1.default)("".concat(classPrefix, "-benefit"), bgClass, className) },
        icon && react_1.default.createElement("div", { className: "icon", style: { backgroundImage: "url(".concat(icon, ")") } }),
        react_1.default.createElement("h2", { className: "title" }, title),
        react_1.default.createElement("p", { className: "describe" }, describe)));
}
exports.default = Benefit;
//# sourceMappingURL=Benefit.js.map